var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSoundwave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 468 357.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M460.09,200.17a6.76,6.76,0,0,1-6.76-6.76V164a6.76,6.76,0,0,1,13.52,0v29.44A6.75,6.75,0,0,1,460.09,200.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.69,214.3a6.77,6.77,0,0,1-6.77-6.76v-57.7a6.77,6.77,0,0,1,13.53,0v57.7A6.76,6.76,0,0,1,431.69,214.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.28,250.65a6.76,6.76,0,0,1-6.76-6.76V113.49a6.76,6.76,0,0,1,13.52,0v130.4A6.75,6.75,0,0,1,403.28,250.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.88,285.53a6.77,6.77,0,0,1-6.77-6.77V78.62a6.77,6.77,0,0,1,13.53,0V278.76A6.77,6.77,0,0,1,374.88,285.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.47,242.41a6.76,6.76,0,0,1-6.76-6.76V121.73a6.77,6.77,0,0,1,13.53,0V235.65A6.77,6.77,0,0,1,346.47,242.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.07,215.36a6.76,6.76,0,0,1-6.76-6.76V148.79a6.76,6.76,0,1,1,13.52,0V208.6A6.76,6.76,0,0,1,318.07,215.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.66,200.14a6.76,6.76,0,0,1-6.76-6.76V164a6.77,6.77,0,0,1,13.53,0v29.38A6.77,6.77,0,0,1,289.66,200.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.26,221.7a6.76,6.76,0,0,1-6.76-6.76V142.45a6.76,6.76,0,1,1,13.52,0v72.49A6.76,6.76,0,0,1,261.26,221.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.85,256.78a6.76,6.76,0,0,1-6.76-6.76V107.36a6.77,6.77,0,0,1,13.53,0V250A6.77,6.77,0,0,1,232.85,256.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.45,307.51a6.77,6.77,0,0,1-6.76-6.77V56.64a6.76,6.76,0,0,1,13.52,0v244.1A6.76,6.76,0,0,1,204.45,307.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.05,357.38a6.77,6.77,0,0,1-6.77-6.76V6.76a6.77,6.77,0,0,1,13.53,0V350.62A6.76,6.76,0,0,1,176.05,357.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.64,285.53a6.77,6.77,0,0,1-6.76-6.77V78.62a6.76,6.76,0,0,1,13.52,0V278.76A6.76,6.76,0,0,1,147.64,285.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.24,242.41a6.77,6.77,0,0,1-6.77-6.76V121.73a6.77,6.77,0,0,1,13.53,0V235.65A6.76,6.76,0,0,1,119.24,242.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.83,202.92a6.76,6.76,0,0,1-6.76-6.76V161.23a6.76,6.76,0,1,1,13.52,0v34.93A6.76,6.76,0,0,1,90.83,202.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,222.11a6.76,6.76,0,0,1-6.76-6.76V142a6.77,6.77,0,0,1,13.53,0v73.32A6.76,6.76,0,0,1,34,222.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.43,260.16a6.77,6.77,0,0,1-6.77-6.77V104a6.77,6.77,0,0,1,13.53,0v149.4A6.77,6.77,0,0,1,62.43,260.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.62,202.92a6.77,6.77,0,0,1-6.77-6.76V161.23a6.77,6.77,0,1,1,13.53,0v34.93A6.76,6.76,0,0,1,5.62,202.92Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundwave);
export default __webpack_public_path__ + "static/media/soundwave.5597f236.svg";
export { ForwardRef as ReactComponent };